module.exports = __webpack_public_path__ + "img/gear.875fbb24.svg";